import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";

import AutoComplete from "antd/es/auto-complete";
import Input from "antd/es/input";
import { CaretDownOutlined, SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { api } from "@redux/api";

import styled from "styled-components";
import { Button } from "antd";

export const ScenarioLookupWrapper = styled.div`
  .ant-select-auto-complete {
    .ant-input-affix-wrapper {
      border-radius: 6px;
      transition: border-color 0.2s ease;
    }
  }
`;

class ScenarioLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selected: null,
    };
  }

  handleEdit = (data) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleEdit(data);
    
  };

  handleDelete = (id) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleDelete(id);
  };

  buildOptions = (data) => {
    const { canWrite, canFullAccess } = this.props;
    return data.map((item) => {
      const isPublic = item.public;
      const showEdit = !isPublic || canWrite;
      const showDelete = !isPublic || canFullAccess;
      return {
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {item.name}
            <span style={{ display: 'flex', gap: 4 }}>
              {showEdit && (
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={this.handleEdit(item)}
                  style={{ color: '#8c8c8c' }}
                />
              )}
              {showDelete && (
                <Button
                  type="text"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={this.handleDelete(item.id)}
                />
              )}
            </span>
          </div>
        ),
        value: item.name,
        id: item.id,
        record: item,
      };
    });
  };

  handleFocus = async (e) => {
    const result = await api.filterScenario("");
    const data = _.get(result, "data.results", []);
    this.setState({ options: this.buildOptions(data) });
  };

  handleSearch = async (e) => {
    const result = await api.filterScenario("issue=" + e);
    const data = _.get(result, "data.results", []);
    this.setState({ options: this.buildOptions(data) });
  };

  handleSelect = (e, record) => {
    this.setState({
      selected: record.record,
      Scenario: e,
    });

    this.props.SelectedScenario(record);
  };

  openScenario = (e, isNewScenario) => {
    this.setState({
      visible: true,
      isNewScenario,
    });
    this.props.handleOpenScenario(true, isNewScenario);
  };

  render() {
    return (
      <ScenarioLookupWrapper>
        <AutoComplete
          style={{ width: "280px" }}
          options={this.state.options}
          onFocus={this.handleFocus}
          onSelect={this.handleSelect}
          onSearch={this.handleSearch}
          value={this.props.value}
          dropdownMatchSelectWidth={false}
          notFoundContent={() => {
            return <div style={{ padding: '12px', textAlign: 'center', color: '#8c8c8c' }}>No Scenario Found</div>;
          }}
          dropdownRender={(menu) => (
            <div>
              {menu}
              <div style={{ borderTop: '1px solid #f0f0f0', padding: '8px', display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="dashed"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={(e) => this.openScenario(e, true)}
                  style={{ width: '90%' }}
                >
                  New Scenario
                </Button>
              </div>
            </div>
          )}
        >
          <Input
            size="medium"
            allowClear
            placeholder="Select a Scenario"
            autoComplete="off"
            prefix={<SearchOutlined style={{ color: 'var(--color-primary, #4482FF)' }} />}
            suffix={<CaretDownOutlined style={{ color: '#bfbfbf' }} />}
          />
        </AutoComplete>
      </ScenarioLookupWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioLookup);
